import { z } from 'zod';
import { UseSchema } from '../../common';

export const model3dUpdateDtoSchema = z.object({
  canLoad: z.boolean().optional(),

  userPositionX: z.number().nullable().optional(),
  userPositionY: z.number().nullable().optional(),
  userPositionZ: z.number().nullable().optional(),

  userRotationX: z.number().nullable().optional(),
  userRotationY: z.number().nullable().optional(),
  userRotationZ: z.number().nullable().optional(),

  userScaleX: z.number().nullable().optional(),
  userScaleY: z.number().nullable().optional(),
  userScaleZ: z.number().nullable().optional(),
});

@UseSchema(model3dUpdateDtoSchema)
export class Model3dUpdateDto {}
export interface Model3dUpdateDto extends z.infer<typeof model3dUpdateDtoSchema> {}
